import { Accessor } from "solid-js";
import { useWebStoreContext } from "~/context/webstore_context";
import { HomeV3RouteData } from "../data/home_v3_route_data";

export function useHomeV3(routeData: Accessor<HomeV3RouteData>) {
  const webstoreContext = useWebStoreContext();

  const hasLimitedBrands = routeData().hasLimitedBrands;

  const getGridCols = () => {
    let brandsCount = routeData()?.brands?.length ?? 0;
    if (brandsCount == 1) {
      return {
        "grid-cols-1 !max-w-[500px]": true,
      };
    } else if (brandsCount == 2) {
      return {
        "grid-cols-1 sm:grid-cols-2 !max-w-[600px]": true,
      };
    } else if (brandsCount == 3) {
      return {
        "grid-cols-1 sm:grid-cols-3": true,
      };
    } else if (brandsCount == 4) {
      return {
        "grid-cols-1 sm:grid-cols-2 !max-w-[600px]": true,
      };
    } else if (brandsCount <= 8) {
      return {
        "grid-cols-1 sm:grid-cols-3": true,
      };
    }
    return {
      "md:grid-cols-4": hasLimitedBrands(),
      "md:grid-cols-5": !hasLimitedBrands(),
      "grid-cols-1": hasLimitedBrands(),
      "grid-cols-3": !hasLimitedBrands(),
    };
  };

  return {
    hasLimitedBrands,
    getGridCols,
  };
}
